import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StateService } from '@uirouter/angular';
import { getSearchResultState, getSearchResultParams } from '../../../pipes/search/search.functions';

import { doGetPromise, setParams } from '../../../config/core.httpclient-utils';
import * as $ from 'jquery';
import * as _ from 'lodash-es';
import { UiService } from '../../../services/core.ui.service';

@Component({
    selector: 'nav-search',
    template: require('./navsearch.html')
})
export class NavSearchComponent implements OnInit, OnChanges {

    @Input() project: any = null;

    protected searchText = '';

    protected include = {
        trackeritem: true,
        scm: false,
        wiki: true,
        docman: true,
        project: false,
        user: false,
        scmcommit: false,
        forum: false
    };
    private searchSubscription = null;
    protected hasSearch = false;
    protected results: any = false;

    protected debouncedSearchShort;
    private debouncedSearchLong;

    protected projectSearchSetting = 0;
    protected showProjectContextSwitch = false;
    protected projectScopeOptions = [
        {
            value: 1,
            description: 'This Project'
        },
        {
            value: 2,
            description: 'My Projects'
        }
    ];

    constructor(
        private httpClient: HttpClient, 
        private stateService: StateService, 
        
        private uiService: UiService
    ) {
        this.debouncedSearchShort = _.debounce(this.search, 250);
        this.debouncedSearchLong = _.debounce(this.search, 750);    
    }
    
    ngOnInit() {
        this.setProjectSearchContext();
    }

    ngOnChanges(changes) {
        this.setProjectSearchContext();

        if (changes.searchText) {
            this.debouncedSearchShort();
        }
    };

    getSectionNames(sectionsArray) {
        var sections = Object.keys(_.pickBy(sectionsArray, function (val) { return val == true; }));
        return sections.join(',');
    };

    toggleInclude(name) {
        _.set(this.include, name, !_.get(this.include, name, false));
        this.debouncedSearchLong();
    };

    refresh() {
        this.results = false;
        this.search();
    };

    openSearchBox = function() {
        $('#navbar-search-form').addClass('open');
        $('#mega-menu-button').removeClass('open');
    };

    goToSearch() {
        $('#navbar-search-form').removeClass('open')

        var params = {
            unixName: this.project?.unixName,
            p: null,
            q: this.searchText,
            s: this.getSectionNames(this.include)
        };

        if (this.stateService.includes('home.project.summary')) {
            params.p = this.project?.unixName;
            this.stateService.go('home.project.summary.search', params);
        } else {
            this.stateService.go('home.search', params);
        }
    };

    eatClick($event) {
        $event.preventDefault(); 
        $event.stopPropagation();
    }

    checkCancelSearch() {
        const isActive = ! _.get(this.searchSubscription, 'closed', true);
        if (isActive ) {
            this.searchSubscription.unsubscribe();
         }
    }

    search() {
        this.checkCancelSearch();
        this.results = false;

        this.hasSearch = (this.searchText != '');
        if (this.hasSearch) {
            if (this.doTrackerItemSearch(this.searchText)) {
                return false;
            }

            var params = {
                p: null,
                q: this.searchText,
                s: this.getSectionNames(this.include),
                page_num: 1,
                page_size: 5
            };

            // If we're in a project, limit results to that project
            if (this.projectSearchSetting == 1 && this.isProjectContext()) {
                params.p = this.project?.unixName;
            }

            // Use rxjs observable for cancelling
            this.searchSubscription = 
                this.httpClient.get('/api/search/', { params: setParams(params) });

            // Use Promise version for handling output
            this.searchSubscription.toPromise()
                .then((response) => {
                    this.results = this.getResults(response);
                }).catch((response) => {
                    console.log('search fail', response);
                    this.uiService.message.showWarning('Sorry, could not fetch the search results', 'Search Failed');
                    this.results = [];
                });
        }
    };

    getResults(response) {
        const sorted = _.orderBy(
            _.get(response, 'items', []),
            ['matchScore', 'title'], ['desc', 'asc']
        );

        const ret = sorted.map((result) => result);

        return ret;
    }

    getResultState = getSearchResultState;
    getResultParams = getSearchResultParams;

    closeDropdown() {
        $('#navbar-search-form').removeClass('open');
    }

    goTo(result) {
        this.closeDropdown();
        const url = `/api/forummessage/${ result.refId }/location`;
        doGetPromise(this.httpClient, url)
            .then((data: any) => {
                this.stateService.go('home.project.summary.forum.read', {
                    unixName: result.project,
                    id: data.forum,
                    thread: data.forumThread,
                    page_num: Math.ceil(data.number / 20)
                });
            }, (err) => console.log(err)
            );
    };


    getSearchScope(stateName) {

        var defaults = {
            trackeritem: true,
            scm: true,  // Code search must remain OFF for now - see #35718, #36159
            wiki: true,
            docman: true,
            project: false,
            user: false,
            scmcommit: false,
            forum: false
        };

        var ctx : any = false;
        // Add a fake child to the current state,
        // so that the loop is simpler to write.
        var path = stateName + '.a';

        // Go up the chain of parent states, and find
        // the closest one with data.searchContext
        while (!ctx) {
            path = path.split('.').slice(0, -1).join('.');
            var s = this.stateService.get(path);
            if (!s) break;
            ctx = _.get(s, 'data.searchContext', false);
        }

        // If we found one, use it to turn search types on/off
        if (ctx) {
            var ret = _.mapValues(defaults, function (v, k, o) {
                return _.includes(ctx, k);
            });
            return ret;
        }

        // If none was found, use the default settings
        return defaults;
    }

    setSearchScope(stateName) {
        this.include = this.getSearchScope(stateName);
    }

    doTrackerItemSearch(searchText) {
        this.checkCancelSearch();
        if (_.startsWith(searchText, '#')) {
            var id = parseInt(searchText.substring(1));

            if (isNaN(id) || id < 1) {
                return false;
            }

            const url = `/api/trackeritem/${ id }`;

            // Use rxjs observable for cancelling
            this.searchSubscription = 
                this.httpClient.get(url);

            // Use Promise version for handling output
            this.searchSubscription.toPromise()
                .then((response: any) => {
                    var ti = response;
                    if (ti && ti.id) {
                        // Fake response-like object 
                        // for the getResults call to process
                        this.results = this.getResults(
                            {
                                items: [{
                                    section: 'trackeritem',
                                    refId: ti.id,
                                    title: '[#' + ti.id + '] ' + ti.summary,
                                    description: ti.tracker.project.name + '/' + ti.tracker.trackerName
                                }]
                            }
                        );
                    } else {
                        this.results = [];
                    }
                }, (err) => {
                    console.log(err);
                    this.results = [];
                }
            );
            return true;
        }
        return false;
    }

    setProjectSearchContext() {
        this.projectSearchSetting = 2;
        this.showProjectContextSwitch = false;

        if (this.isProjectContext()) {
            this.projectSearchSetting = 1;
            this.showProjectContextSwitch = true;
        }
    }

    isProjectContext() {
        return this.stateService.includes('home.project') && _.has(this.project, 'unixName');
    }
}